import React from 'react';
import { FolderInput, Brain, Users, Sliders } from 'lucide-react';

const STEPS = [
  {
    icon: FolderInput,
    title: 'Drop your work folder',
    body:
      'Point Sortio at your Downloads, Desktop, or shared Dropbox where deliverables, contracts, and grant narratives accumulate. Sortio scans them on your machine.',
  },
  {
    icon: Brain,
    title: 'AI reads each file',
    body:
      "Sortio's AI extracts client names, project codes, document types, and dates from each file. PDFs, Word docs, and PowerPoint decks are all read on your machine. In Offline mode (Ollama) or with BYOK, that content stays on device; by default Sortio uses our cloud to plan the sort and sends filenames and paths, with file contents sent only if you enable a content-based feature.",
  },
  {
    icon: Users,
    title: 'Per-client, per-project routing',
    body:
      'Each file lands in the right client folder and project subfolder. A grant narrative for one funder never ends up in the folder for a different funder. Naming conventions get enforced automatically: dates in front, project code in the middle, version at the end.',
  },
  {
    icon: Sliders,
    title: 'Rule Builder for multi-business',
    body:
      'Running three companies out of one Downloads folder? The Rule Builder routes by entity (a consulting practice, a retail shop, a holding company) using filename patterns, file content, or source. Rules run locally and can be tuned without touching the cloud.',
  },
];

const Workflow = () => {
  return (
    <section id="workflow" className="my-20">
      <div className="text-center mb-14">
        <h2 className="text-3xl sm:text-4xl font-semibold mb-4 tracking-tight text-apple-50">
          How it works
        </h2>
        <p className="text-apple-300 text-lg font-light max-w-2xl mx-auto">
          Four steps from a blended Downloads folder to clean, per-client, per-project deliverables.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {STEPS.map((step, i) => {
          const Icon = step.icon;
          return (
            <div
              key={i}
              className="relative bg-apple-800/40 backdrop-blur-sm rounded-2xl border border-apple-700/50 p-6 flex flex-col"
            >
              <div className="flex items-center mb-4">
                <div className="w-10 h-10 rounded-full bg-sortio-primary/15 border border-sortio-primary/30 flex items-center justify-center mr-3">
                  <Icon className="text-sortio-primary" size={18} />
                </div>
                <span className="text-xs font-medium uppercase tracking-wider text-apple-400">
                  Step {i + 1}
                </span>
              </div>
              <h3 className="text-lg font-medium text-apple-50 mb-2">{step.title}</h3>
              <p className="text-sm text-apple-200 leading-relaxed">{step.body}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Workflow;
